export default [
	{
		subDeviceName: '燃气表',
		subDeviceType: 'meter',
		x: '50.7%',
		y: '83%',
		linePosition: 'bottom',
		detail: {
			data: [
				{ key: 'meterReading', label: '读数' },
				{ key: 'valveStatus', label: '阀门状态' },
				{ key: 'usePrice', label: '单价' },
				{ key: 'meterBalance', label: '余额' },
				{ key: 'deviceConnectStatus', label: '连接状态' },
				{ key: 'isAlarm', label: '告警状态' },
			],
			style: {
				top: '0',
				left: '118%',
				marginTop: '-130%',
			},
			arrow: {
				style: {
					top: '50%',
					left: '0',
					marginTop: '-4px',
					marginLeft: '-15px',
				},
			},
			showDeviceDetailsBtn: true,
		},
	},
	{
		subDeviceName: '电磁阀',
		subDeviceType: 'solenoidValve',
		x: '47.6%',
		y: '75.2%',
		linePosition: 'bottom',
		detail: {
			data: [
				{ key: 'deviceConnectStatus', label: '连接状态' },
				{ key: 'lastCommunicateTime', label: '最后通讯时间' },
			],
			style: {
				top: '-60%',
				right: '124%',
			},
			arrow: {
				style: {
					top: '28%',
					right: '-15px',
					transform: 'rotate(180deg)',
				},
			},
			showDeviceDetailsBtn: true,
		},
	},
	{
		subDeviceName: '燃气灶',
		subDeviceType: 'gasStove',
		x: '69%',
		y: '70.5%',
		linePosition: 'bottom',
		detail: {
			data: [
				{ key: 'leftSwitch', label: '左炉状态' },
				{ key: 'rightSwitch', label: '右炉状态' },
				{ key: 'lastCommunicateTime', label: '点火开始时间' },
				{ key: 'deviceConnectStatus', label: '连接状态' },
			],
			style: {
				top: '-121%',
				left: '121%',
			},
			arrow: {
				style: {
					top: '36%',
					left: '-15px',
				},
			},
		},
	},
	{
		subDeviceName: '中控屏',
		subDeviceType: 'centralControlScreen',
		x: '50%',
		y: '52.5%',
		linePosition: 'bottom',
		detail: {
			data: [
				{ key: 'deviceConnectStatus', label: '连接状态' },
				{ key: 'lastCommunicateTime', label: '最后通讯时间' },
			],
			style: {
				top: '-70%',
				left: '118%',
			},
			arrow: {
				style: {
					top: '38%',
					left: '0',
					marginLeft: '-15px',
				},
			},
			showDeviceDetailsBtn: true,
		},
	},
	{
		subDeviceName: '油烟机',
		subDeviceType: 'kitchenHood',
		x: '67.5%',
		y: '38.8%',
		linePosition: 'bottom',
		detail: {
			data: [
				{ key: 'deviceConnectStatus', label: '连接状态' },
				{ key: 'ventilatorSwitch', label: '开关状态' },
			],
			style: {
				top: '-80%',
				left: '118%',
			},
			arrow: {
				style: {
					top: '46%',
					left: '-15px',
				},
			},
		},
	},
	{
		subDeviceName: '报警器',
		subDeviceType: 'alarm',
		x: '54.2%',
		y: '11.8%',
		linePosition: 'top',
		detail: {
			data: [
				{ key: 'isAlarm', label: '报警状态' },
				{ key: 'density', label: '燃气浓度' },
				{ key: 'deviceConnectStatus', label: '连接状态' },
			],
			style: {
				top: '-121%',
				left: '121%',
			},
			arrow: {
				style: {
					top: '35%',
					left: '-15px',
				},
			},
			showDeviceDetailsBtn: true,
		},
	},
	{
		subDeviceName: '安全灯',
		subDeviceType: 'safetyLight',
		x: '47.2%',
		y: '15%',
		linePosition: 'top',
		detail: {
			data: [
				{ key: 'deviceConnectStatus', label: '连接状态' },
				{ key: 'safeLightStatus', label: '开关状态' },
			],
			style: {
				top: '130%',
				left: '0',
			},
			arrow: {
				style: {
					top: '-15px',
					left: '30%',
					transform: 'rotate(90deg)',
				},
			},
			showDeviceDetailsBtn: true,
		},
	},
	{
		subDeviceName: '热水器',
		subDeviceType: 'waterHeater',
		x: '39.5%',
		y: '22.8%',
		linePosition: 'bottom',
		detail: {
			data: [
				{ key: 'deviceConnectStatus', label: '连接状态' },
				{ key: 'heaterSwitch', label: '开关状态' },
			],
			style: {
				top: '-50%',
				right: '124%',
			},
			arrow: {
				style: {
					top: '32%',
					right: '-15px',
					transform: 'rotate(180deg)',
				},
			},
		},
	},
	{
		subDeviceName: '开窗器',
		subDeviceType: 'popup',
		x: '27.5%',
		y: '62.8%',
		linePosition: 'bottom',
		detail: {
			data: [
				{ key: 'deviceConnectStatus', label: '连接状态' },
				{ key: 'openDegree', label: '开窗角度' },
			],
			style: {
				top: '-100%',
				right: '121%',
			},
			arrow: {
				style: {
					top: '38%',
					right: '-15px',
					transform: 'rotate(180deg)',
				},
			},
			showDeviceDetailsBtn: true,
		},
	},
]
